module.exports = __webpack_public_path__ + "static/img/wjp90.ca18465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/wjp90.png
// module id = CHLc
// module chunks = 0